var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ot-tag",class:_vm.className,attrs:{"data-deliver-part":"deliver-code"}},[(this.status)?_c('div',{staticClass:"ot-tag__dot"}):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.computedText))])])}
var staticRenderFns = []

export { render, staticRenderFns }